import { useImmer } from "use-immer";
import { useRef, useState, useEffect, useContext } from "react";
import SimpleReactValidator from "simple-react-validator";
import { useDebounce } from "use-debounce";
import { useDelete, usePermission } from "../../../shared";
import { AppContext } from "../../../store";
import { useSyncHistoryListQueries } from "./useSyncHistoryListQueries";

export const useSyncHistoryList = () => {
  const isUnitCreate = usePermission("unit-create");
  const isUnitEditable = usePermission("unit-modify");
  const isUnitDeletable = usePermission("unit-delete");
  const [, forceUpdate] = useState();
  const validator = useRef(
    new SimpleReactValidator({ autoForceUpdate: { forceUpdate: forceUpdate } }),
  );
  const { deleteInfo, onDelete, resetDeleteInfo } = useDelete();
  const moduleName = "syncHistory";
  const {
    tableData,
    setSorting,
    setPagination,
    setTableState,
    setSearchState,
    clearAllFilters,
  } = useContext(AppContext);
  const { sorting, pagination, search } = tableData[moduleName];
  const [state, setState] = useImmer({
    isLoading: true,
    dataList: {},
    filters: {},
    remarks: "",
    isOpenMoreModal: false,
  });

  const [debouncedText] = useDebounce(search, 1000);

  const { listQuery } = useSyncHistoryListQueries({
    selectedStatus: tableData?.syncHistory?.data?.selectedStatus,
    pagination,
    sorting,
    selectedDate: tableData?.syncHistory?.data?.selectedDate,
    selectedStatus: tableData?.syncHistory?.data?.selectedStatus,
    debouncedText,
  });

  useEffect(() => {
    // getUnits();
    if (listQuery?.data) {
      setState((draft) => {
        draft.dataList = listQuery?.data || [];
        draft.isLoading = false;
      });
    }
  }, [listQuery?.data]);

  const onSearchHandler = (search) => {
    setSearchState({
      tableName: moduleName,
      key: "search",
      value: search,
    });
    setPagination({
      tableName: moduleName,
      callback: (prevPagination) => ({
        ...prevPagination,
        pageIndex: 1,
      }),
    });
  };

  const onDateChangeHandler = (date) => {
    setTableState({
      tableName: moduleName,
      key: "selectedDate",
      value: date,
    });
    setPagination({
      tableName: moduleName,
      callback: (prevPagination) => ({
        ...prevPagination,
        pageIndex: 1,
      }),
    });
  };

  const onChangeStatusHandler = (value) => {
    setTableState({
      tableName: moduleName,
      key: "selectedStatus",
      value: value?.id,
    });
    setPagination({
      tableName: moduleName,
      callback: (prevPagination) => ({
        ...prevPagination,
        pageIndex: 1,
      }),
    });
  };

  const onClearFilter = () => {
    clearAllFilters({ tableName: moduleName });
  };

  const selectedDate = tableData?.syncHistory?.data?.selectedDate;

  const selectedStatus = tableData?.syncHistory?.data?.selectedStatus;

  const disableclearButton = !(
    (selectedDate !== null && selectedDate !== "") ||
    (selectedStatus !== null && selectedStatus !== "")
  );

  const handleMoreModal = (isOpen, value = "") => {
    setState((draft) => {
      draft.remarks = value;
      draft.isOpenMoreModal = isOpen;
    });
  };

  return {
    state,
    listQuery,
    pagination,
    setPagination,
    sorting,
    setSorting,
    search,
    setSearchState,
    moduleName,
    onSearchHandler,
    onDateChangeHandler,
    tableData,
    onChangeStatusHandler,
    disableclearButton,
    onClearFilter,
    handleMoreModal,
  };
};
